module.exports = __webpack_public_path__ + "img/extension-title-new.05a712d9.png";